import { render, staticRenderFns } from "./PricelistsReadOnly.vue?vue&type=template&id=e4efa984"
import script from "./PricelistsReadOnly.vue?vue&type=script&lang=js"
export * from "./PricelistsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports